import ForgeryProtection from "lib/ForgeryProtection"

// Applies the CSRF token to form fields on CDN-cached pages that have no
// server-rendered token.
//
// The _csrf_fetch_script partial sets window._csrfResolve/Reject to signal those pages.
//
// ForgeryProtection.CSRF is already called by common.js so this piggybacks on
// that same fetch to avoid an extra request.
if (typeof window._csrfResolve === "function") {
  ForgeryProtection.CSRF.then(({ token }) => {
    document.querySelectorAll('input[name="authenticity_token"]').forEach((el) => {
      el.value = token
    })
    window.csrfTokenApplied = true
    window._csrfResolve()
  }).catch(() => {
    const errorEl = document.getElementById("csrf-fetch-error")
    if (errorEl) errorEl.hidden = false
    window._csrfReject()
  })
}
